export const lpTokenValue = (
  lpTokenBalance: number,
  pair: ILiquidityPair,
  rate?: number,
): number => {
  const singleToken = !pair.token1;
  const tokenPrice = singleToken
    ? rate || 0
    : parseFloat(pair.reserveUSD) / parseFloat(pair.totalSupply);

  // Guard against invalid calculations
  if (!Number.isFinite(tokenPrice) || tokenPrice <= 0) {
    // console.warn('[lpTokenValue] Invalid token price calculated:', {
    //   singleToken,
    //   rate,
    //   reserveUSD: pair.reserveUSD,
    //   totalSupply: pair.totalSupply,
    //   calculatedPrice: tokenPrice,
    // });
    return 0;
  }

  const value = lpTokenBalance * tokenPrice;

  // Guard against invalid results
  if (!Number.isFinite(value) || value < 0) {
    // console.warn('[lpTokenValue] Invalid value calculated:', {
    //   lpTokenBalance,
    //   tokenPrice,
    //   calculatedValue: value,
    // });
    return 0;
  }

  return value;
};
